import React, {Fragment} from "react";
import {PhoneOutlined} from "@ant-design/icons"

import ModalContact from "../modals/ModalContact";
import AppService from "../services/AppService"
import ApiService from "../services/ApiService";
import {Fab, Action} from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';

export default class CallFab extends React.Component {

    state = {
        show: false,
        phone: null,
        id: null,
    }

    componentDidMount() {
        console.log("CREATE CALL DETECTOR LISTENER")
        this.removeListener = AppService.addEventListener("call.detector", (event) => {
            var data = event.data
            console.log("call.detector", data)

            if (data.phone && ["Incoming", "Offhook", "Connected", "Dialing"].includes(data.state)) {
                this.setState({phone: data.phone, show: true}, () => this.getData())
            }

            if (["Missed", "Disconnected"].includes(data.state)) {
                this.setState({id: null, show: false})
            }
        })
    }

    componentWillUnmount() {
        this.removeListener()
    }

    async getData() {
        var res = await ApiService.get("/contact/phone/" + this.state.phone)
        console.log(res)

        if (res.success) {
            this.setState({show: true, id: res.id})
        } else {
            this.setState({show: false, id: null})
        }
    }

    render() {


        return (
            <div style={{position: "absolute", bottom: 130, right: 110, zIndex: 10000}}>

                {this.state.show && this.state.id && (
                    <Fab
                        mainButtonStyles={{backgroundColor: "#5cb85c"}}
                        style={{}}
                        icon={<PhoneOutlined/>}
                        alwaysShowTitle={true}
                        onClick={() => {
                            if (this.state.id) {
                                this.modalContact.show(this.state.id)
                            }
                        }}
                    />
                )}

                <ModalContact getRef={(ref) => this.modalContact = ref}/>
            </div>
        )

    }
}
